import type { Area } from 'react-easy-crop'

export async function cropImageToJpeg(file: File, area: Area, maxSize: number): Promise<File> {
  const bitmap = await createImageBitmap(file)
  try {
    const scale = Math.min(1, maxSize / Math.max(area.width, area.height))
    const canvas = document.createElement('canvas')
    canvas.width = Math.max(1, Math.round(area.width * scale))
    canvas.height = Math.max(1, Math.round(area.height * scale))
    const context = canvas.getContext('2d')
    if (!context) throw new Error('Image editing is unavailable in this browser')
    context.fillStyle = '#fff'
    context.fillRect(0, 0, canvas.width, canvas.height)
    context.drawImage(
      bitmap,
      area.x,
      area.y,
      area.width,
      area.height,
      0,
      0,
      canvas.width,
      canvas.height
    )
    const blob = await new Promise<Blob | null>((resolve) =>
      canvas.toBlob(resolve, 'image/jpeg', 0.9)
    )
    if (!blob) throw new Error('Could not save this image')
    return new File([blob], `${file.name.replace(/\.[^.]*$/, '')}.jpg`, { type: 'image/jpeg' })
  } finally {
    bitmap.close()
  }
}
